import { createAsyncThunk } from "@reduxjs/toolkit";
import api, { normalizeError } from "../../services/api";

export const fetchGrievances = createAsyncThunk(
  "grievances/fetchAll",
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/api/grievances", { params });
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const createGrievance = createAsyncThunk(
  "grievances/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/grievances", payload);
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const updateGrievance = createAsyncThunk(
  "grievances/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/api/grievances/${id}`, payload);
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const deleteGrievance = createAsyncThunk(
  "grievances/delete",
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/api/grievances/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const fetchGrievancePdf = createAsyncThunk(
  "grievances/fetchPdf",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/api/grievances/${id}/pdf`);
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const sendGrievanceEmails = createAsyncThunk(
  "grievances/sendEmails",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/grievances/send-emails");
      return data;
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);
